module.exports = __webpack_public_path__ + "img/shelvxiaofeifenxi.725ac958.png";